import { defineMessages } from 'react-intl';

/** The copy of the Theme panel of a song (design q2, q2b, q4) and of "Make them again". */
export const themeMessages = defineMessages({
  title: { id: 'app.sml.releases.theme.title', defaultMessage: 'Theme' },
  hint: {
    id: 'app.sml.releases.theme.hint',
    defaultMessage: 'One feeling for every asset of this song: images, short videos and the AI reel.',
  },
  hintNarrow: { id: 'app.sml.releases.theme.hintNarrow', defaultMessage: 'One feeling for every asset of this song.' },
  edit: { id: 'app.sml.releases.theme.edit', defaultMessage: 'Edit theme' },
  collapse: { id: 'app.sml.releases.theme.collapse', defaultMessage: 'Done' },
  tiles: { id: 'app.sml.releases.theme.tiles', defaultMessage: 'Theme' },
  defaultBadge: { id: 'app.sml.releases.theme.defaultBadge', defaultMessage: 'Default' },
  samplesNote: {
    id: 'app.sml.releases.theme.samplesNote',
    defaultMessage: 'The samples use the song Swamps by LaziiBee. The preview shows your song.',
  },
  samplesNoteNarrow: {
    id: 'app.sml.releases.theme.samplesNoteNarrow',
    defaultMessage: 'Swipe for all 8. The samples use the song Swamps by LaziiBee.',
  },
  liveCaption: { id: 'app.sml.releases.theme.live.caption', defaultMessage: 'Your song in {theme}' },
  liveNote: {
    id: 'app.sml.releases.theme.live.note',
    defaultMessage: 'A still in the colours of your cover and the type of the theme. The assets move.',
  },
  kickerOutNow: { id: 'app.sml.releases.theme.kicker.outNow', defaultMessage: 'Out now' },
  kickerPreSave: { id: 'app.sml.releases.theme.kicker.preSave', defaultMessage: 'Pre-save now' },
  fontTitle: { id: 'app.sml.releases.theme.font.title', defaultMessage: 'Title font: {font}' },
  fontOfTheme: { id: 'app.sml.releases.theme.font.ofTheme', defaultMessage: 'The font of {theme}.' },
  fontChosen: {
    id: 'app.sml.releases.theme.font.chosen',
    defaultMessage: 'Your choice. The font of {theme} is {font}.',
  },
  fontReset: { id: 'app.sml.releases.theme.font.reset', defaultMessage: 'Use the theme font' },
  fontOpen: { id: 'app.sml.releases.theme.font.open', defaultMessage: 'Change font' },
  fontClose: { id: 'app.sml.releases.theme.font.close', defaultMessage: 'Close' },
  fontGroup: { id: 'app.sml.releases.theme.font.group', defaultMessage: 'Title font' },
  fontThemeBadge: { id: 'app.sml.releases.theme.font.themeBadge', defaultMessage: 'Theme' },
  coloursTitle: { id: 'app.sml.releases.theme.colours.title', defaultMessage: 'Colours' },
  coloursCover: {
    id: 'app.sml.releases.theme.colours.cover',
    defaultMessage: 'Taken from your cover. Change a colour if they look bad.',
  },
  coloursOwn: {
    id: 'app.sml.releases.theme.colours.own',
    defaultMessage: 'Your colours. The theme builds its colours from them.',
  },
  coloursReset: { id: 'app.sml.releases.theme.colours.reset', defaultMessage: 'Reset to cover colours' },
  coloursSwatch: { id: 'app.sml.releases.theme.colours.swatch', defaultMessage: 'Colour {number}' },
  coloursHex: { id: 'app.sml.releases.theme.colours.hex', defaultMessage: 'Colour {number} hex code' },
  coloursLowContrast: {
    id: 'app.sml.releases.theme.colours.lowContrast',
    defaultMessage:
      'The text of {theme} is hard to read on these colours (contrast {ratio}:1, the goal is 4.5:1). You can still save them.',
  },
  logoTitle: { id: 'app.sml.releases.theme.logo.title', defaultMessage: 'Your logo' },
  logoHint: {
    id: 'app.sml.releases.theme.logo.hint',
    defaultMessage: 'PNG with a clear background. It goes on end cards and banners.',
  },
  logoPlaceholder: { id: 'app.sml.releases.theme.logo.placeholder', defaultMessage: 'Logo' },
  logoAdd: { id: 'app.sml.releases.theme.logo.add', defaultMessage: 'Add' },
  logoReplace: { id: 'app.sml.releases.theme.logo.replace', defaultMessage: 'Replace' },
  logoRemove: { id: 'app.sml.releases.theme.logo.remove', defaultMessage: 'Remove' },
  saveDefault: { id: 'app.sml.releases.theme.saveDefault', defaultMessage: 'Save as my default' },
  saveDefaultHint: {
    id: 'app.sml.releases.theme.saveDefaultHint',
    defaultMessage:
      'New songs of {artist} start with this theme, this font and this logo. The colours still come from the artwork of each song.',
  },
  draftNote: {
    id: 'app.sml.releases.theme.draft.note',
    defaultMessage: 'The preview shows your change. It is not saved yet.',
  },
  draftSave: { id: 'app.sml.releases.theme.draft.save', defaultMessage: 'Save' },
  draftSaving: { id: 'app.sml.releases.theme.draft.saving', defaultMessage: 'Saving…' },
  draftCancel: { id: 'app.sml.releases.theme.draft.cancel', defaultMessage: 'Cancel' },
  leaveTitle: { id: 'app.sml.releases.theme.leave.title', defaultMessage: 'Leave without saving the theme?' },
  leaveBody: {
    id: 'app.sml.releases.theme.leave.body',
    defaultMessage: 'The theme of {title} has a change that is not saved. If you leave, the change goes.',
  },
  saved: { id: 'app.sml.releases.theme.saved', defaultMessage: 'The theme is saved as your default.' },
  saveFailed: { id: 'app.sml.releases.theme.saveFailed', defaultMessage: 'The theme could not be saved. Try again.' },
  staleOne: {
    id: 'app.sml.releases.theme.stale.one',
    defaultMessage:
      '{count, plural, one {# asset of this song uses {oldTheme}.} other {# assets of this song use {oldTheme}.}}',
  },
  staleMixed: {
    id: 'app.sml.releases.theme.stale.mixed',
    defaultMessage:
      '{count, plural, one {# asset of this song uses an older theme.} other {# assets of this song use older themes.}}',
  },
  staleColours: {
    id: 'app.sml.releases.theme.stale.colours',
    defaultMessage:
      '{count, plural, one {# asset of this song uses the old colours.} other {# assets of this song use the old colours.}}',
  },
  staleNewColours: {
    id: 'app.sml.releases.theme.stale.newColours',
    defaultMessage: 'New assets use the new colours.',
  },
  staleNew: { id: 'app.sml.releases.theme.stale.new', defaultMessage: 'New assets use {theme}.' },
  showThem: { id: 'app.sml.releases.theme.stale.show', defaultMessage: 'Show them' },
  makeAgain: { id: 'app.sml.releases.theme.stale.makeAgain', defaultMessage: 'Make them again' },
  madeInColours: { id: 'app.sml.releases.theme.madeInColours', defaultMessage: 'Made in the old colours' },
  madeIn: { id: 'app.sml.releases.theme.madeIn', defaultMessage: 'Made in {theme}' },
  remakeTitle: {
    id: 'app.sml.releases.theme.remake.title',
    defaultMessage: '{count, plural, one {Make # asset again in {theme}?} other {Make # assets again in {theme}?}}',
  },
  remakeDescription: {
    id: 'app.sml.releases.theme.remake.description',
    defaultMessage:
      'Each asset gets a new version with the same settings, in the theme of the song. The older versions stay in the version list.',
  },
  remakeChecking: { id: 'app.sml.releases.theme.remake.checking', defaultMessage: 'Checking the cost…' },
  remakeCost: {
    id: 'app.sml.releases.theme.remake.cost',
    defaultMessage:
      '{credits, plural, =0 {Images are free. This uses no credit.} one {Videos use # credit. Images are free.} other {Videos use # credits. Images are free.}}',
  },
  remakeConfirm: {
    id: 'app.sml.releases.theme.remake.confirm',
    defaultMessage:
      '{credits, plural, =0 {Make them again} one {Make them again · # credit} other {Make them again · # credits}}',
  },
  remakeCheckFailed: {
    id: 'app.sml.releases.theme.remake.checkFailed',
    defaultMessage: 'MUSIC24 could not check the cost. Try again.',
  },
  remakeFailed: {
    id: 'app.sml.releases.theme.remake.failed',
    defaultMessage: 'MUSIC24 could not make the assets again. Try again.',
  },
  remakeStarted: {
    id: 'app.sml.releases.theme.remake.started',
    defaultMessage: '{count, plural, one {# asset is being made again.} other {# assets are being made again.}}',
  },
  dialogTitle: { id: 'app.sml.releases.theme.dialog.title', defaultMessage: 'Theme of {title}' },
  dialogDone: { id: 'app.sml.releases.theme.dialog.done', defaultMessage: 'Done' },
  studioHint: { id: 'app.sml.releases.theme.studioHint', defaultMessage: 'Changes apply to this song.' },
});
